var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheTopBar',{attrs:{"controls":_vm.controls,"with-fullscreen-button":"","menu-offset":_vm.menuOffset}})
}
var staticRenderFns = []

export { render, staticRenderFns }